import BaseModel from './BaseModel';
import {Movie} from './Movies';
import ModelArray from './ModelArray';
import Cinema from './Cinema'

import moment from 'moment';

export default class FilmFestival extends BaseModel {

    constructor(data) {
        super();
        Object.assign(this, data);
        this.Movies = this.Movies ? new ModelArray(this.Movies, Movie) : [];
        this.Cinemas = this.Cinemas ? new ModelArray(this.Cinemas, Cinema) : [];

        this.StartDate = this.StartDate ? moment(this.StartDate) : {
            format:()=>null
        };

    }
}


// WEBPACK FOOTER //
// ../hasta-la-vista-middleware-api/src/model/FilmVestival.js